import { IconChevronDown } from '@tabler/icons-solidjs'
import { type JSX, splitProps } from 'solid-js'
import { cn } from '../lib/cn.ts'
import { tv } from '../lib/tv.ts'

/**
 * Shares --size-control-md with Input and Button so mixed control rows align by definition.
 *
 * The Tabler chevron replaces the platform affordance so macOS and Windows render the same
 * control. The wrapper is layout-only; all form attributes and refs still land on the select.
 */
const select = tv({
  base: [
    'h-(--size-control-md) w-full appearance-none rounded-control pr-8 pl-control-x-sm',
    'border border-border bg-surface text-body text-text',
    'outline-none transition-[border-color,background-color] duration-(--duration-fast) ease-out',
    'hover:border-border-strong',
    'focus:border-accent focus:bg-surface focus:ring-0',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
    'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:text-text-subtle',
  ],
})

export type SelectProps = JSX.SelectHTMLAttributes<HTMLSelectElement>

export const Select = (props: SelectProps) => {
  const [local, rest] = splitProps(props, ['class', 'style'])

  return (
    <span class="relative block w-full">
      <select
        {...rest}
        class={cn(select(), local.class)}
        style={local.style as JSX.CSSProperties}
      />
      <IconChevronDown
        size={14}
        strokeWidth={1.5}
        class="pointer-events-none absolute top-1/2 right-2.5 -translate-y-1/2 text-text-subtle"
        aria-hidden="true"
      />
    </span>
  )
}
